import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ElementRef, Input } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs/Observable';

// Reducers
import * as Auth from '../../../../auth/actions/auth.actions';
import * as fromAuth from '../../../../auth/reducers';
import * as fromCore from '../../../../core/reducers';

// Actions
import * as UIActions from '../../../../core/actions/ui.actions';

@Component({
  selector: 'user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss'],
  host: { '(document:click)': 'onClick($event)' }
})
export class UserDropdownComponent implements OnInit, OnDestroy {

  @Input() type: string = 'client';
  // Dropdown opened
  public dropdownOpened: boolean = false;

  // User information
  public userInformation$: Observable<any> = this.store.select(state => state.auth.login.user);

  // Auth Token
  private authToken: string = '';
  private storeSubscription;

  // Constructor
  constructor(
    private _eref: ElementRef,
    private store: Store<fromAuth.State>,
    private coreStore: Store<fromCore.State>,
    private router: Router
  ) { }

  // On component init
  ngOnInit() {
    this.storeSubscription = this.store.select(state => state.auth.login.token).subscribe(token => {
      this.authToken = token;
    });
  }

  // On component destroy
  ngOnDestroy() {
    this.storeSubscription.unsubscribe();
  }

  // On element click
  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // Logout
  onLogout() {
    this.store.dispatch(new Auth.Logout());
  }

  // Navigate to MyProjects
  toMyProjects() {
    this.dropdownOpened = false;
    this.router.navigateByUrl('/admin/my-projects');
  }

  // Navigate to MyAccount
  toMyAccount() {
    this.dropdownOpened = false;
    if (this.type === 'staff'){
      this.router.navigateByUrl('/staff/my-account');
      // Dispatch Project Selection Action
      this.coreStore.dispatch(new UIActions.SelectProjectSection(null));
    }
    else{
      this.router.navigateByUrl('/admin/my-account');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/header-bar/user-dropdown/user-dropdown.component.ts